import ReplyViewModel from "@domains/event/viewModel/ReplyViewModel";

import ReplyCard from "../ReplyCard/ReplyCard";

import * as S from "./ReplyList.style";

interface ReplyListProps {
  currentUserId: number;
  eventId: string;
  commentId: number;
  replyList: ReplyViewModel[];
}

const ReplyList = ({
  currentUserId,
  eventId,
  commentId,
  replyList,
}: ReplyListProps) => {
  return (
    <S.ReplyListWrapper>
      {replyList?.map((reply) => (
        <ReplyCard
          key={reply.id}
          isMySelf={reply.authorId === currentUserId}
          eventId={eventId}
          commentId={commentId}
          replyId={reply.id}
          commenterName={reply.authorName}
          authorName={reply.authorName}
          authorId={reply.authorId}
          authorProfile={reply.profileImage}
          repliedPayload={reply.content}
          repliedAt={reply.commentedAt}
        />
      ))}
    </S.ReplyListWrapper>
  );
};

export default ReplyList;
